import {faArrowLeft} from "@fortawesome/free-solid-svg-icons/faArrowLeft";
import {faArrowRight} from "@fortawesome/free-solid-svg-icons/faArrowRight";
import {useEffect, useId} from "react";
import FontAwesomeButton from "../cards/FontAwesomeButton";
import EditableEntry from "../editable_entries/EditableEntry";

const PaginationFilter = ({filter, onEdit, maxPage}) => {
    // console.log(filter);
    let id = useId();

    useEffect(() => {
        if (filter.page > maxPage) {
            onEdit({page: Math.max(maxPage - 1, 0)});
        }
    }, [maxPage]);

    return (
        <div style={{fontSize: "0.75rem", display: "flex", justifyContent: "space-between", userSelect: "none"}}>
            <EditableEntry
                isEditing={true}
                label={"Page"}
                editingChildren={<div style={{marginTop: "0.25rem", marginBottom: "0.25rem"}}>
                    <FontAwesomeButton
                        icon={faArrowLeft}
                        enabled={filter.page > 0}
                        onClick={filter.page ? () => onEdit({page: filter.page - 1}) : undefined}
                    />
                    <span>{(filter.page ?? 0) + 1} of {Math.max(maxPage, 1)}</span>
                    <FontAwesomeButton
                        icon={faArrowRight}
                        enabled={filter.page < maxPage - 1}
                        onClick={filter.page < maxPage - 1 ? () => onEdit({page: filter.page + 1}) : undefined}
                    />
                </div>}
            />
            <EditableEntry
                id={id}
                label={"Items per page"}
                isEditing={true}
                editingChildren={
                    <select
                        id={id}
                        value={filter.size}
                        onChange={(e) => onEdit({size: Number(e.target.value)})}
                    >
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                    </select>
                }
            />
        </div>
    );
};

export default PaginationFilter;